'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');
var getSystem = require('@mx/util/get-system');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: [_vm.fixed ? 'nav-fixed' : 'nav', {
        'nav-with-status-bar': _vm.isIOS && _vm.withStatusBar
      }]
    }, [_vm.left || _vm.arrow ? _c('div', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      class: ['nav-left'],
      on: {
        "click": function click($event) {
          _vm.$emit('clickLeft');
        }
      }
    }, [_vm.arrow ? _c('i', {
      staticClass: "icon-back"
    }) : _vm._e(), _vm._v(" "), _vm.left ? _c('div', {
      staticClass: "left-label",
      domProps: {
        "innerHTML": _vm._s(_vm.left)
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.$slots.left ? _c('div', {
      staticClass: "nav-left has-slot"
    }, [_vm._t("left")], 2) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "nav-title",
      domProps: {
        "innerHTML": _vm._s(_vm.title)
      }
    }), _vm._v(" "), _vm.right ? _c('div', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      staticClass: "nav-right",
      domProps: {
        "innerHTML": _vm._s(_vm.right)
      },
      on: {
        "click": function click($event) {
          _vm.$emit('clickRight');
        }
      }
    }) : _vm._e(), _vm._v(" "), _vm.$slots.right ? _c('div', {
      staticClass: "nav-right has-slot"
    }, [_vm._t("right")], 2) : _vm._e()]);
  },
  staticRenderFns: [],
  name: 'nav',
  props: {
    left: String,
    right: String,
    title: String,
    arrow: Boolean,
    fixed: Boolean,
    withStatusBar: Boolean
  },
  data: function data() {
    return {
      isIOS: getSystem.getSystem() === 'ios'
    };
  }
});

exports.default = index;
